export default "__VITE_ASSET__CxDNO0ce__"